import _ from 'lodash'
import {
  UPDATE_LISTING_IMAGE,
  ADD_LISTING_IMAGE,
  SET_LISTING,
  CHANGE_LISTING,
  INIT_LISTING,
  ADD_LISTING_PORTAL,
} from '../constants/actions'
import { setIn } from '../modules/utils'
import config from '../config'

const initListing = {
  title: config.getLangText(),
  tags: {
    th: [],
    en: [],
    zh: [],
  },
  internalRemark: "",
  description: config.getLangText(),
  portals: [],
  profiles: ['default'],
  isUseInWeb: false
}

export default (state = initListing, action) => {
  switch (action.type) {
    case INIT_LISTING:
      return {
        ...initListing,
        modifiedDate: new Date().toISOString(),
      }
    case SET_LISTING:
      return {
        ...state,
        ...action.listing,
      }
    case CHANGE_LISTING:
      return setIn(action.path, action.value, state)
    case UPDATE_LISTING_IMAGE:
    case ADD_LISTING_IMAGE:
      return {
        ...state,
        mainImageId: action.mainImageId,
        mainImageLastChecked: action.mainImageLastChecked,
      }
    case ADD_LISTING_PORTAL:
      const portalList = _.maxBy(state.portals, 'listingSeq')
      const lastedSeq = portalList ? portalList.listingSeq : 0
      const portal = action.portal
      const newListingPortal = {
        info: portal,
        ref: portal._id,
        hostRef: portal.hostRef,
        status: 'RELEASE',
        version: 0,
        listingSeq: lastedSeq + 1,
      }
      return {
        ...state,
        portals: [...state.portals, newListingPortal],
        modifiedDate: new Date().toISOString(),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listing.js